import { Link, Outlet } from "@tanstack/react-router"
import { ChartNoAxesColumn, History, House, type LucideIcon, UserRound } from "lucide-react"
import { ChildSwitcher } from "@/features/children/ChildSwitcher"
import { useSelectedChild } from "@/features/children/useSelectedChild"
import { SleepDrawer } from "@/features/sleep/SleepDrawer"

export function AppShell() {
  const { selectedChild } = useSelectedChild()

  const navLink = (to: string, label: string, Icon: LucideIcon) => (
    <Link
      key={to}
      to={to}
      aria-label={label}
      activeOptions={{ exact: to === "/" }}
      className="flex size-11 items-center justify-center rounded-full text-foreground/75 transition-colors hover:text-foreground data-[status=active]:bg-accent/15 data-[status=active]:text-accent"
    >
      <Icon className="size-6" />
    </Link>
  )

  return (
    <div className="relative mx-auto flex min-h-dvh w-full max-w-[30rem] flex-col">
      <div className="safe-area-top absolute top-0 left-4 z-20">
        <ChildSwitcher />
      </div>

      <main className="flex-1 overflow-y-auto pt-[calc(4rem+env(safe-area-inset-top))] pb-28">
        <Outlet />
      </main>

      <div className="safe-area-bottom pointer-events-none fixed inset-x-0 bottom-0 z-30 flex justify-center">
        <nav className="pointer-events-auto flex items-center gap-3 rounded-full border border-border/80 bg-card/90 px-6 py-2 shadow-xl shadow-black/40 backdrop-blur-md">
          {navLink("/", "Hem", House)}
          {navLink("/historik", "Historik", History)}
          {selectedChild && <SleepDrawer childId={selectedChild.id} />}
          {navLink("/statistik", "Statistik", ChartNoAxesColumn)}
          {navLink("/profil", "Profil", UserRound)}
        </nav>
      </div>
    </div>
  )
}
